import { ViewModel,View, ObservableArray } from "binder"
import  { SaleBenefitsReportView } from "./saleBenefitsReport-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ExcelExporter } from "src/common/utilities";
import { Converters } from "src/uicomponents/converters";

export class SaleBenefitsReportViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گزارش سود فروش';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<Item>();
        this.filterItems = ObservableArray.create<Item>();
        this.from = moment.utc();
        this.until = moment.utc();
    }
    GetDefaultView(): View <ViewModel> {
        return new SaleBenefitsReportView();
    }
    public getTypeId(): string {
        return "VM-1F4C32C9-E2A5-4303-8609-48CD532861FC"
    }

    public set items(v: ObservableArray<Item>) { this._items = v; } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;
    public set filterItems(v: ObservableArray<Item>) { this._filterItems = v;} public get filterItems(): ObservableArray<Item> { return this._filterItems;} private _filterItems: ObservableArray<Item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set sumSetPrice(v: number) { this._sumSetPrice = v; } public get sumSetPrice(): number { return this._sumSetPrice;} private _sumSetPrice: number;
    public set sumSoldPrice(v: number) { this._sumSoldPrice = v; } public get sumSoldPrice(): number { return this._sumSoldPrice;} private _sumSoldPrice: number;
    public set benefitRateMean(v: number) { this._benefitRateMean = v; } public get benefitRateMean(): number { return this._benefitRateMean;} private _benefitRateMean: number;
    public set expectedBenefitMean(v: number) { this._expectedBenefitMean = v; } public get expectedBenefitMean(): number { return this._expectedBenefitMean;} private _expectedBenefitMean: number;
    public set realDollarMean(v: number) { this._realDollarMean = v; } public get realDollarMean(): number { return this._realDollarMean;} private _realDollarMean: number;
    public set dollarRateMean(v: number) { this._dollarRateMean = v; } public get dollarRateMean(): number { return this._dollarRateMean;} private _dollarRateMean: number;
    public set dollarPriceMean(v: number) { this._dollarPriceMean = v; } public get dollarPriceMean(): number { return this._dollarPriceMean;} private _dollarPriceMean: number;
    public set currentDollarMean(v: number) { this._currentDollarMean = v; } public get currentDollarMean(): number { return this._currentDollarMean;} private _currentDollarMean: number;
    
    public set from(v: moment.Moment) { 
        let v2 = v.clone().local().hour(4).minute(30).second(0).millisecond(0)
        this._from = v2; 
    } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { 
        let v2 = v.clone().local().hour(23).minute(59).second(59).millisecond(999)
        this._until = v2; 
    } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
        
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/SaleBenefitReport',{
                FromDateTime : this.from,
                UntilDateTime : this.until
            });
            this.items.update(...result.Reports.map((x,i)=>{
                let r = new Item(this);
                r.index = i+1;
                r.productCode = x.ProductCode;
                r.productName = x.ProductName;
                r.productCarBrand = x.ProductCarBrand;
                r.productBrand = x.ProductBrand;
                r.sellerName = x.SellerName;
                r.districtName = x.DistrictName;
                r.customerName = x.CustomerName;
                r.dollarPrice = x.DollarPrice;
                r.currentDollarPrice = x.CurrentDollarPrice;
                r.setFeeDollarPrice = Math.round(x.SetDollarPrice * 100) / 100;
                r.amount = x.Amount;
                r.setDollarPrice = Math.round(r.amount * r.setFeeDollarPrice * 100) / 100;
                r.factorNo = x.FactorNo;
                r.factorTime = x.FactorTime != null ? moment.utc(x.FactorTime) : null;
                r.purchaseTime = x.PurchaseTime != null ? moment.utc(x.PurchaseTime) : null;
                r.benefitRate = x.BenefitRate;
                r.expectedBenefitRate = x.ExpectedBenefitRate;
                r.realDollarPrice = x.RealDollarPrice;
                r.dollarRate = r.dollarPrice != 0 ? Math.round(10000 * r.realDollarPrice / r.dollarPrice) / 100 : 0;
                r.soldPriceFee = x.SalePrice;
                r.soldPrice = x.SalePrice * x.Amount;
                r.systemPriceFee = x.SystemPrice;
                r.sumOfSoldAmount = x.SumOfSoldAmount;

                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    calculateSum(){
        let itemsCount = this.filterItems.length;
        if (itemsCount != 0) {
            this.sumSetPrice = Math.round(this.filterItems.reduce((s,q) => q.setDollarPrice + s, 0) * 100)/ 100;
            this.sumSoldPrice = this.filterItems.reduce((s,q) => q.soldPrice + s, 0);
            this.dollarPriceMean = Math.round(this.filterItems.reduce((s,q) => (q.dollarPrice + s) , 0) * 100 / itemsCount) / 100;
            this.realDollarMean = Math.round(this.filterItems.filter(q => q.realDollarPrice != 0).reduce((s,q) => (q.realDollarPrice + s), 0) * 100 / this.filterItems.filter(q => q.realDollarPrice != 0).length) / 100;
            this.currentDollarMean = Math.round(this.filterItems.reduce((s,q) => (q.currentDollarPrice + s), 0) * 100 / itemsCount) / 100;
            this.expectedBenefitMean = Math.round(this.filterItems.reduce((s,q) => (q.expectedBenefitRate + s), 0) * 100 / itemsCount) / 100;
            this.benefitRateMean = Math.round(this.filterItems.reduce((s,q) => (q.benefitRate + s), 0) * 100 / itemsCount) / 100;
            this.dollarRateMean = Math.round(this.filterItems.filter(q => q.dollarRate != 0).reduce((s,q) => (q.dollarRate + s), 0) * 100 / this.filterItems.filter(q => q.dollarRate != 0).length) / 100;
        } else {
            itemsCount = this.items.length;
            this.sumSetPrice = Math.round(this.items.reduce((s,q) => q.setDollarPrice + s, 0 * 100 )) / 100;
            this.sumSoldPrice = this.items.reduce((s,q) => q.soldPrice + s, 0);
            this.dollarPriceMean = Math.round(this.items.reduce((s,q) => (q.dollarPrice + s) , 0) * 100 / itemsCount) / 100;
            this.realDollarMean = Math.round(this.items.filter(q => q.realDollarPrice != 0).reduce((s,q) => (q.realDollarPrice + s), 0) * 100 / this.items.filter(q => q.realDollarPrice != 0).length) / 100;
            this.currentDollarMean = Math.round(this.items.reduce((s,q) => (q.currentDollarPrice + s), 0) * 100 / itemsCount) / 100;
            this.expectedBenefitMean = Math.round(this.items.reduce((s,q) => (q.expectedBenefitRate + s), 0) * 100 / itemsCount) / 100;
            this.benefitRateMean = Math.round(this.items.reduce((s,q) => (q.benefitRate + s), 0) * 100 / itemsCount) / 100;
            this.dollarRateMean = Math.round(this.items.filter(q => q.dollarRate != 0).reduce((s,q) => (q.dollarRate + s), 0) * 100 / this.items.filter(q => q.dollarRate != 0).length) / 100;
        }
    }

    exportExcel(){
        let converter = new Converters();
        new ExcelExporter().export('سود فروش.xlsx',this.items.map(x=>{
            return {
                'ردیف':x.index,
                'کد کالا':x.productCode,
                'نام کالا':x.productName,
                'گروه خودرو':x.productCarBrand,
                'برند کالا':x.productBrand,
                'نام مشتری':x.customerName,
                'نام فروشنده':x.sellerName,
                'شعبه فروشنده':x.districtName,
                'تاریخ فاکتور':converter.onlyDateNoWeekDayPersianDateConverter(x.factorTime),
                'ساعت فاکتور':converter.onlyTimePersianDateConverter(x.factorTime),
                'تاریخ آخرین خرید':converter.onlyDateNoWeekDayPersianDateConverter(x.purchaseTime),
                'ساعت آخرین خرید':converter.onlyTimePersianDateConverter(x.purchaseTime),
                'شماره فاکتور':x.factorNo,
                'تعداد اقلام':x.amount,
                'قیمت سیستمی':x.systemPriceFee,
                'فی فروش رفته':x.soldPriceFee,
                'قیمت فروش رفته':x.soldPrice,
                'قیمت دلار':x.dollarPrice,
                'قیمت فعلی دلار':x.currentDollarPrice,
                'قیمت دلار واقعی':x.realDollarPrice,
                'فی مقدار ست':x.setFeeDollarPrice,
                'مقدار ست':x.setDollarPrice,
                'نسبت دلار':x.dollarRate,
                'درصد سود':x.benefitRate,
                'درصد سود پیش بینی شده':x.expectedBenefitRate,
                'مجموع فروش رفته':x.sumOfSoldAmount,
            };
        }))
    }
}

export class Item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set factorTime(v: moment.Moment) { this._factorTime = v; } public get factorTime(): moment.Moment { return this._factorTime;} private _factorTime: moment.Moment;
    public set purchaseTime(v: moment.Moment) { this._purchaseTime = v; } public get purchaseTime(): moment.Moment { return this._purchaseTime;} private _purchaseTime: moment.Moment;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set productCarBrand(v: string) { this._productCarBrand = v; } public get productCarBrand(): string { return this._productCarBrand;} private _productCarBrand: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set realDollarPrice(v: number) { this._realDollarPrice = v; } public get realDollarPrice(): number { return this._realDollarPrice;} private _realDollarPrice: number;
    public set dollarPrice(v: number) { this._dollarPrice = v; } public get dollarPrice(): number { return this._dollarPrice;} private _dollarPrice: number;
    public set currentDollarPrice(v: number) { this._currentDollarPrice = v; } public get currentDollarPrice(): number { return this._currentDollarPrice;} private _currentDollarPrice: number;
    public set setDollarPrice(v: number) { this._setDollarPrice = v; } public get setDollarPrice(): number { return this._setDollarPrice;} private _setDollarPrice: number;
    public set setFeeDollarPrice(v: number) { this._setFeeDollarPrice = v; } public get setFeeDollarPrice(): number { return this._setFeeDollarPrice;} private _setFeeDollarPrice: number;
    public set dollarRate(v: number) { this._dollarRate = v; } public get dollarRate(): number { return this._dollarRate;} private _dollarRate: number;
    public set benefitRate(v: number) { this._benefitRate = v; } public get benefitRate(): number { return this._benefitRate;} private _benefitRate: number;
    public set expectedBenefitRate(v: number) { this._expectedBenefitRate = v; } public get expectedBenefitRate(): number { return this._expectedBenefitRate;} private _expectedBenefitRate: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set factorNo(v: number) { this._factorNo = v; } public get factorNo(): number { return this._factorNo;} private _factorNo: number;
    public set soldPriceFee(v: number) { this._soldPriceFee = v; } public get soldPriceFee(): number { return this._soldPriceFee;} private _soldPriceFee: number;
    public set soldPrice(v: number) { this._soldPrice = v; } public get soldPrice(): number { return this._soldPrice;} private _soldPrice: number;
    public set systemPriceFee(v: number) { this._systemPriceFee = v; } public get systemPriceFee(): number { return this._systemPriceFee;} private _systemPriceFee: number;
    public set sumOfSoldAmount(v: number) { this._sumOfSoldAmount = v; } public get sumOfSoldAmount(): number { return this._sumOfSoldAmount;} private _sumOfSoldAmount: number;
    
}
